"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const SearchAddressDialog_1 = require("@/common/components/SearchAddressDialog");
const Button_1 = __importDefault(require("@mui/material/Button"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1({ settingAddressForm, isRegionKR, needEnAddress, }) {
    const [showDaumPostcodeDialog, setShowDaumPostcodeDialog] = (0, react_1.useState)(false);
    const openDaumPostcodeDialog = () => setShowDaumPostcodeDialog(true);
    const closeDaumPostcodeDialog = () => setShowDaumPostcodeDialog(false);
    const [showGooglePlaceSearchDialog, setShowGooglePlaceSearchDialog] = (0, react_1.useState)(false);
    const openGooglePlaceSearchDialog = () => setShowGooglePlaceSearchDialog(true);
    const closeGooglePlaceSearchDialog = () => setShowGooglePlaceSearchDialog(false);
    const { clearErrors, setValue, setFocus } = settingAddressForm;
    const onSearchAddressClick = () => {
        isRegionKR ? openDaumPostcodeDialog() : openGooglePlaceSearchDialog();
        clearErrors('root.noAddress');
    };
    const onSelectDaumPostcode = (daumAddress) => {
        const { zonecode, userSelectedType, roadAddress, address, roadAddressEnglish, addressEnglish } = daumAddress;
        setValue('post_code', zonecode, { shouldDirty: true });
        setValue('address', userSelectedType === 'R' ? roadAddress : address, { shouldDirty: true });
        setValue('address_detail', '', { shouldDirty: true });
        if (needEnAddress) {
            setValue('en_address', userSelectedType === 'R' ? roadAddressEnglish : addressEnglish, {
                shouldDirty: true,
            });
            setValue('en_address_detail', '', { shouldDirty: true });
        }
        clearErrors(['post_code', 'address', 'address_detail', 'en_address', 'en_address_detail']);
        closeDaumPostcodeDialog();
        setFocus('address_detail');
        (0, _1.scrollToCAAddressDetailInput)();
    };
    const onSelectGooglePlace = (address) => {
        setValue('address', address, { shouldDirty: true });
        clearErrors('address');
        closeGooglePlaceSearchDialog();
        setFocus('post_code');
        (0, _1.scrollToCAPostCodeInput)();
    };
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ sx: {
                    flex: 1,
                    columnGap: '6px',
                    width: '100%',
                    height: '40px',
                    borderRadius: '12px',
                    fontSize: '15px',
                    backgroundColor: 'rgba(0, 0, 0, 0.8) !important',
                    color: 'white',
                }, onClick: onSearchAddressClick }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.LocationIconWhiteSvg, {}), t('주소 찾기')] })), (0, jsx_runtime_1.jsx)(SearchAddressDialog_1.SearchDaumPostcodeDialog, { open: showDaumPostcodeDialog, closeDialog: closeDaumPostcodeDialog, onSelectDaumPostcode: onSelectDaumPostcode, maxWidth768: maxWidth768 }), (0, jsx_runtime_1.jsx)(SearchAddressDialog_1.SearchGooglePlaceDialog, { open: showGooglePlaceSearchDialog, closeDialog: closeGooglePlaceSearchDialog, onSelectGooglePlace: onSelectGooglePlace, maxWidth768: maxWidth768 })] }));
}
exports.default = default_1;
